<template>
  <div class="page-loading">LOADING</div>
</template>

<script>
export default {
  name: "page-loading"
};
</script>
